import React from "react";
import { Switch, Route } from "react-router";
import HomePage from "./containers/HomePage";
import CounterPage from "./containers/CounterPage";
import CategoryPage from "./containers/CategoryPage";
import LoginPage from "./containers/LoginPage";

export default () => (
  <Switch>
    <Route path="/" exact component={HomePage} />
    <Route path="/categories" exact component={CategoryPage} />
    <Route path="/counter" exact component={CounterPage} />
    <Route path="/login" exact component={LoginPage} />
    <Route path="*" component={HomePage} />
  </Switch>
);
